// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__39Ik_","container":"styles_container__FFlHQ","title":"styles_title__1qlu8","wrapper":"styles_wrapper__3Ngps","answer":"styles_answer__d7Zhj"};